export default __webpack_public_path__ + "static/quarter2-bc977e2789c8ea27b6e61b3e2d3e84c7.png";